<div class="missions-page">
  <section class="missions-page__main">
    <header class="missions-page__header">
      <div>
        <h1>{{ 'promotions.missions.title' | translate }}</h1>
        <p>{{ 'promotions.missions.count' | translate: { count: totalMissionsCount() } }}</p>
      </div>

      <div
        class="missions-page__filters"
        role="tablist"
        [attr.aria-label]="'promotions.missions.filtersLabel' | translate"
      >
        @for (filter of statusFilters; track filter.id) {
          <button
            type="button"
            role="tab"
            class="missions-page__filter"
            [class.missions-page__filter--active]="selectedStatus() === filter.id"
            [attr.aria-selected]="selectedStatus() === filter.id"
            (click)="selectStatus(filter.id)"
          >
            {{ filter.label | translate }}
          </button>
        }
      </div>
    </header>

    @if (isActiveStatus()) {
      @if (activeCampaignsIsLoading()) {
        <div class="missions-page__state" aria-live="polite">
          <korviu-loader></korviu-loader>
        </div>
      } @else if (activeCampaignsLoadError()) {
        <div class="missions-page__state" role="alert">
          <p>{{ 'promotions.missions.loadError' | translate }}</p>
          <button type="button" (click)="loadActiveCampaigns()">
            {{ 'promotions.missions.retry' | translate }}
          </button>
        </div>
      } @else if (!campaignMissions().length) {
        <div class="missions-page__state">
          <korviu-no-data size="medium" [message]="'promotions.missions.empty' | translate"></korviu-no-data>
        </div>
      } @else {
        <div
          class="missions-page__featured"
          [swipeNavigation]="featuredMissions().length > 1"
          (onSwipeLeft)="changeFeaturedMission(1)"
          (onSwipeRight)="changeFeaturedMission(-1)"
        >
          @for (mission of featuredMissions(); track mission.id) {
            <article
              class="missions-page__featured-card"
              [class.missions-page__featured-card--hidden]="mission.id !== selectedFeaturedMissionId()"
              [attr.aria-busy]="detailsLoadingCampaignId() === mission.id"
              role="button"
              tabindex="0"
              (click)="openCampaignDetails(mission)"
              (keydown.enter)="openCampaignDetails(mission)"
              (keydown.space)="openCampaignDetails(mission); $event.preventDefault()"
            >
              <div
                class="missions-page__featured-icon"
                [class.missions-page__featured-icon--tree]="mission.iconVariant === 'tree'"
                [class.missions-page__featured-icon--sprout]="mission.iconVariant === 'sprout'"
                [class.missions-page__featured-icon--card]="mission.iconVariant === 'card'"
              >
                @switch (mission.iconVariant) {
                  @case ('tree') {
                    <svg width="24" height="24" viewBox="0 0 19 20" fill="none" aria-hidden="true">
                      <path
                        d="M9.5 0C7.6553 0 6.08637 1.17468 5.4981 2.81638C3.50929 3.17156 2 4.90934 2 7C2 7.36664 2.04659 7.72309 2.13432 8.0634C0.85949 8.7966 0 10.1722 0 11.75C0 13.9526 1.67511 15.7633 3.8214 15.9786C3.87864 15.9926 3.93845 16 4 16H7V18.25C7 19.2165 7.7835 20 8.75 20H10.25C11.2165 20 12 19.2165 12 18.25V16H15C15.0615 16 15.1214 15.9926 15.1786 15.9786C17.3249 15.7633 19 13.9526 19 11.75C19 10.1722 18.1405 8.7966 16.8657 8.0634C16.9534 7.7231 17 7.36664 17 7C17 4.90933 15.4907 3.17156 13.5019 2.81638C12.9136 1.17468 11.3447 0 9.5 0ZM10.5 16V18.25C10.5 18.3881 10.3881 18.5 10.25 18.5H8.75C8.6119 18.5 8.5 18.3881 8.5 18.25V16H10.5ZM4.11472 14.5C4.09435 14.4969 4.0737 14.4945 4.0528 14.4931C2.62643 14.3924 1.5 13.2024 1.5 11.75C1.5 10.5589 2.25764 9.5429 3.31967 9.1611C3.51718 9.0901 3.67592 8.9396 3.7573 8.7462C3.83869 8.5527 3.83529 8.334 3.74792 8.1431C3.58897 7.79596 3.5 7.40939 3.5 7C3.5 5.5263 4.65954 4.32299 6.11556 4.25321C6.45467 4.23696 6.74057 3.99494 6.81259 3.66317C7.08111 2.42616 8.1833 1.5 9.5 1.5C10.8167 1.5 11.9189 2.42616 12.1874 3.66317C12.2594 3.99494 12.5453 4.23696 12.8844 4.25321C14.3405 4.32299 15.5 5.5263 15.5 7C15.5 7.40939 15.411 7.79596 15.2521 8.1431C15.1647 8.334 15.1613 8.5527 15.2427 8.7462C15.3241 8.9396 15.4828 9.0901 15.6803 9.1611C16.7424 9.5429 17.5 10.5589 17.5 11.75C17.5 13.2024 16.3736 14.3924 14.9472 14.4931C14.9263 14.4945 14.9056 14.4969 14.8853 14.5H4.11472Z"
                        fill="currentColor"
                      />
                    </svg>
                  }
                  @case ('sprout') {
                    <svg width="24" height="24" viewBox="0 0 24 26.6665" fill="none" aria-hidden="true">
                      <path
                        d="M12 0C9.7908 0 8 1.79087 8 4V9.33333C8 11.1972 9.27477 12.7633 11 13.2073V16.9191L6.37377 12.2929C5.98325 11.9024 5.35008 11.9024 4.95956 12.2929C4.56904 12.6835 4.56904 13.3165 4.95956 13.7071L11 19.7476V21.6667C11 22.2189 11.4477 22.6667 12 22.6667C12.5523 22.6667 13 22.2189 13 21.6667V19.7476L19.0404 13.7071C19.4309 13.3165 19.4309 12.6835 19.0404 12.2929C18.6499 11.9024 18.0168 11.9024 17.6263 12.2929L13 16.9191V13.2073C14.7252 12.7633 16 11.1972 16 9.33333V4C16 1.79087 14.2092 0 12 0ZM10 4C10 2.89543 10.8955 2 12 2C13.1045 2 14 2.89543 14 4V9.33333C14 10.4379 13.1045 11.3333 12 11.3333C10.8955 11.3333 10 10.4379 10 9.33333V4ZM3.85531 17.3387C4.51388 17.0792 5.24351 16.8524 6.0296 16.6628L7.72116 18.3543C6.53272 18.5617 5.47207 18.8513 4.58835 19.1995C3.6618 19.5644 2.97969 19.9743 2.54599 20.3783C2.11373 20.7808 2 21.1043 2 21.3332C2 21.5621 2.11373 21.8856 2.54599 22.2881C2.97969 22.6921 3.6618 23.1019 4.58835 23.4669C6.43547 24.1945 9.05551 24.6665 12 24.6665C14.9445 24.6665 17.5645 24.1945 19.4116 23.4669C20.3383 23.1019 21.0203 22.6921 21.454 22.2881C21.8863 21.8856 22 21.5621 22 21.3332C22 21.1043 21.8863 20.7808 21.454 20.3783C21.0203 19.9743 20.3383 19.5644 19.4116 19.1995C18.5279 18.8513 17.4673 18.5617 16.2788 18.3543L17.9704 16.6628C18.7565 16.8524 19.4861 17.0792 20.1447 17.3387C21.2088 17.7579 22.1376 18.2817 22.8171 18.9147C23.4981 19.5489 24 20.3655 24 21.3332C24 22.3009 23.4981 23.1173 22.8171 23.7517C22.1376 24.3845 21.2088 24.9085 20.1447 25.3277C18.0107 26.1684 15.1307 26.6665 12 26.6665C8.86936 26.6665 5.9894 26.1684 3.85531 25.3277C2.79125 24.9085 1.86243 24.3845 1.18288 23.7517C0.501867 23.1173 0 22.3009 0 21.3332C0 20.3655 0.501867 19.5489 1.18288 18.9147C1.86243 18.2817 2.79125 17.7579 3.85531 17.3387Z"
                        fill="currentColor"
                      />
                    </svg>
                  }
                  @case ('card') {
                    <svg width="24" height="24" viewBox="0 0 26.6667 18.6667" fill="none" aria-hidden="true">
                      <path
                        d="M18.3333 12.6667C17.7811 12.6667 17.3333 13.1144 17.3333 13.6667C17.3333 14.2189 17.7811 14.6667 18.3333 14.6667H21.6667C22.2189 14.6667 22.6667 14.2189 22.6667 13.6667C22.6667 13.1144 22.2189 12.6667 21.6667 12.6667H18.3333ZM0 4.33333C0 1.94009 1.94009 0 4.33333 0H22.3333C24.7265 0 26.6667 1.94009 26.6667 4.33333V14.3333C26.6667 16.7265 24.7265 18.6667 22.3333 18.6667H4.33333C1.94009 18.6667 0 16.7265 0 14.3333V4.33333ZM24.6667 6V4.33333C24.6667 3.04467 23.622 2 22.3333 2H4.33333C3.04467 2 2 3.04467 2 4.33333V6H24.6667ZM2 8V14.3333C2 15.622 3.04467 16.6667 4.33333 16.6667H22.3333C23.622 16.6667 24.6667 15.622 24.6667 14.3333V8H2Z"
                        fill="currentColor"
                      />
                    </svg>
                  }
                }
              </div>

              @if (mission.category; as category) {
                <span class="missions-page__category-pill">{{ category }}</span>
              }

              <h2>{{ mission.name }}</h2>
              <p>{{ mission.description }}</p>

              @if (mission.reward; as reward) {
                <span class="missions-page__reward-pill">
                  @if (reward.value) {
                    {{ reward.value }}
                  }
                  {{ 'promotions.campaignDetails.rewardTypes.' + reward.reward_type | translate }}
                </span>
              }

              @if (mission.objective_progress; as objectiveProgress) {
                <div class="missions-page__progress missions-page__progress--featured">
                  <span>
                    <i [style.width.%]="mission.progress"></i>
                  </span>
                  <p>
                    {{
                      'promotions.missions.objectiveProgress'
                        | translate
                          : {
                              current: objectiveProgress.current,
                              target: objectiveProgress.target
                            }
                    }}
                  </p>
                </div>
              }
            </article>
          }
        </div>

        @if (featuredMissions().length > 1) {
          <div
            class="missions-page__slider-dots"
            [attr.aria-label]="'promotions.missions.featuredNavigation' | translate"
          >
            @for (mission of featuredMissions(); track mission.id) {
              <button
                type="button"
                [class.missions-page__slider-dot--active]="mission.id === selectedFeaturedMissionId()"
                [attr.aria-label]="mission.name"
                [attr.aria-current]="mission.id === selectedFeaturedMissionId() ? 'true' : null"
                (click)="selectFeaturedMission(mission.id)"
              ></button>
            }
          </div>
        }

        @if (missions().length) {
          <div class="missions-page__list">
            @for (mission of missions(); track mission.id) {
              <article
                class="missions-page__mission-card"
                [attr.aria-busy]="detailsLoadingCampaignId() === mission.id"
                role="button"
                tabindex="0"
                (click)="openCampaignDetails(mission)"
                (keydown.enter)="openCampaignDetails(mission)"
                (keydown.space)="openCampaignDetails(mission); $event.preventDefault()"
              >
                <div class="missions-page__mission-content">
                  <div class="missions-page__mission-row">
                    <img class="missions-page__mission-icon" [src]="mission.icon" [alt]="mission.name" />

                    <div class="missions-page__mission-copy">
                      <h2>{{ mission.name }}</h2>
                      <p>{{ mission.description }}</p>
                    </div>

                    <span class="missions-page__mission-link" aria-hidden="true">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M8.25 5.5 12.75 10l-4.5 4.5"
                          stroke="currentColor"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>

                  <div class="missions-page__mission-metadata">
                    @if (mission.category; as category) {
                      <span class="missions-page__category-pill">{{ category }}</span>
                    }
                    @if (mission.reward; as reward) {
                      <span class="missions-page__reward-pill">
                        @if (reward.value) {
                          {{ reward.value }}
                        }
                        {{ 'promotions.campaignDetails.rewardTypes.' + reward.reward_type | translate }}
                      </span>
                    }
                  </div>

                  @if (mission.objective_progress; as objectiveProgress) {
                    <div class="missions-page__progress">
                      <span>
                        <i [style.width.%]="mission.progress"></i>
                      </span>
                      <p>
                        {{
                          'promotions.missions.objectiveProgress'
                            | translate
                              : {
                                  current: objectiveProgress.current,
                                  target: objectiveProgress.target
                                }
                        }}
                      </p>
                    </div>
                  }
                </div>
              </article>
            }
          </div>
        }

        @if (detailsLoadingCampaignId() !== null) {
          <div class="missions-page__details-state" aria-live="polite">
            <korviu-loader></korviu-loader>
            <span>{{ 'promotions.missions.detailsLoading' | translate }}</span>
          </div>
        } @else if (detailsLoadError()) {
          <p class="missions-page__details-error" role="alert">
            {{ 'promotions.missions.detailsLoadError' | translate }}
          </p>
        }
      }
    } @else {
      @if (completedCampaignsIsLoading()) {
        <div class="missions-page__state" aria-live="polite">
          <korviu-loader></korviu-loader>
        </div>
      } @else if (completedCampaignsLoadError()) {
        <div class="missions-page__state" role="alert">
          <p>{{ 'promotions.missions.completed.loadError' | translate }}</p>
          <button type="button" (click)="loadCompletedCampaigns()">
            {{ 'promotions.missions.retry' | translate }}
          </button>
        </div>
      } @else if (!completedCampaigns().length) {
        <div class="missions-page__state">
          <korviu-no-data size="medium" [message]="'promotions.missions.completed.empty' | translate"></korviu-no-data>
        </div>
      } @else {
        <div class="missions-page__completed-grid">
          @for (mission of pagedCompletedMissions(); track mission.id) {
            <a class="missions-page__completed-card" [routerLink]="['/workspace/promotions/campaign', mission.id]">
              <div class="missions-page__completed-icon" aria-hidden="true">
                @switch (mission.campaign_type) {
                  @case ('sweepstakes') {
                    <img src="assets/img/promotions/missions/completed-planting.svg" alt="" />
                  }
                  @case ('fx4y') {
                    <img src="assets/img/promotions/missions/completed-community.svg" alt="" />
                  }
                  @case ('instant_win') {
                    <img src="assets/img/missions/mission-icon.svg" alt="" />
                  }
                }
              </div>
              <strong>
                {{
                  (mission.user_progress.entries_count === 1
                    ? 'promotions.missions.entriesCount'
                    : 'promotions.missions.entriesCount_other'
                  ) | translate: { count: mission.user_progress.entries_count }
                }}
              </strong>
              <span>{{ mission.name }}</span>
              <small>
                {{ 'promotions.campaignDetails.types.' + mission.campaign_type | translate }}
              </small>
              @if (mission.objective; as objective) {
                <small>
                  {{ 'promotions.campaignDetails.objectives.' + objective.action | translate }}
                  · {{ objective.min_count }}
                </small>
              }
              @if (mission.top_reward; as reward) {
                <small>
                  @if (reward.value) {
                    {{ reward.value }}
                  }
                  {{ 'promotions.campaignDetails.rewardTypes.' + reward.reward_type | translate }}
                </small>
              }
              <small>{{ 'promotions.campaignDetails.statuses.' + mission.status | translate }}</small>
              @if (mission.claim_status; as claimStatus) {
                <small>
                  {{ 'promotions.campaignDetails.claimStatuses.' + claimStatus | translate }}
                </small>
              }
            </a>
          }
        </div>

        <nav
          class="missions-page__completed-pagination"
          [attr.aria-label]="'promotions.missions.completed.pages' | translate"
        >
          <button
            type="button"
            [disabled]="!canGoToPreviousCompletedPage()"
            [attr.aria-label]="'promotions.missions.completed.previousPage' | translate"
            (click)="goToCompletedPage(completedPage() - 1)"
          >
            ‹
          </button>
          @for (page of completedPageNumbers(); track page) {
            <button
              type="button"
              [class.missions-page__completed-page--active]="completedPage() === page"
              [attr.aria-current]="completedPage() === page ? 'page' : null"
              (click)="goToCompletedPage(page)"
            >
              {{ page }}
            </button>
          }
          <button
            type="button"
            [disabled]="!canGoToNextCompletedPage()"
            [attr.aria-label]="'promotions.missions.completed.nextPage' | translate"
            (click)="goToCompletedPage(completedPage() + 1)"
          >
            ›
          </button>
        </nav>
      }

      <a routerLink="/workspace/profile/recent-activity" class="missions-page__activity-link">
        {{ 'promotions.missions.completed.viewActivity' | translate }}
      </a>
    }
  </section>

  <aside class="missions-page__aside">
    @if (isBannerVisible() && isActiveStatus()) {
      <section class="missions-page__banner">
        <picture>
          <source media="(min-width: 768px)" srcset="assets/img/promotions/missions/banner-desktop.png" />
          <img src="assets/img/promotions/missions/banner-mobile.png" alt="" aria-hidden="true" />
        </picture>

        <div>
          <h2>{{ 'promotions.missions.banner.title' | translate }}</h2>
          <p>{{ 'promotions.missions.banner.description' | translate }}</p>
        </div>

        <button
          type="button"
          [attr.aria-label]="'promotions.missions.banner.close' | translate"
          (click)="closeBanner()"
        >
          <span aria-hidden="true">x</span>
        </button>
      </section>
    }

    <section class="missions-page__stat-card">
      <div class="missions-page__stat-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M9.5 4.5h5l1.25 2.25 2.25 1.25v4.5l-2.25 1.25L14.5 16h-5l-1.25-2.25L6 12.5V8l2.25-1.25L9.5 4.5Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path d="m10 12 4-4M10 16l4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>
      <strong>{{ totalEntriesEarned() }}</strong>
      <p>{{ 'promotions.missions.entriesEarned' | translate }}</p>
    </section>

    <section class="missions-page__chart-card">
      <h2>{{ 'promotions.missions.chart.title' | translate }}</h2>

      <div class="missions-page__donut" aria-hidden="true">
        <div>
          <strong>{{ completedCampaignsCount() }}</strong>
          <span>{{ 'promotions.missions.chart.missions' | translate }}</span>
        </div>
      </div>
    </section>
  </aside>
</div>
